<template>
    <div>
        <!-- <el-select clearable v-model="searchArr.chat_id" filterable remote reserve-keyword placeholder="输入群名搜素" size="mini"
            :remote-method="searchNameremoteMethod" :loading="searchLoading" @change="handleSearchNameChange">
            <el-option v-for="searchChat in searchChatList" :key="searchChat.chat_id" :label="searchChat.name"
                :value="searchChat.chat_id">
            </el-option>
        </el-select> -->

        <el-input v-model="searchArr.chat_id" placeholder="输入群名搜素" size="mini" clearable :loading="searchLoading"
            prefix-icon="el-icon-search">
        </el-input>

        <div style="padding: 0.2rem 0.2rem">
            <GroupOnly :chat_id="ChatId" @doBind="doBind" @doRealBind="execBind" />
            <!-- <div style="margin-top:0.2rem">
                <el-button v-show="doBindStatus" type="primary" size="mini" style="float: right"
                    @click="execBind">绑定</el-button>
            </div> -->
        </div>
        <div style="padding: 0.2rem 0.2rem;" v-show="order_num_chat_data.length > 0">
            <span style="color: #409EFF;font-size: large;font-weight: bold;">系统检测到该订单属于企业微信聊天群:</span>
            <div style="margin-top: 0.2rem;">
                <ChatGroup :group_info="order_num_chat_data" @doRealBind="execBind"/>
            </div>
        </div>
    </div>
</template>

<script>
import ChatGroup from './ChatGroup'
import GroupOnly from 'common/GroupInfoOnly'
export default {
    name: 'BindWeChat',
    props: {
        order_num: {
            type: String
        }
    },
    components: { GroupOnly,ChatGroup },
    data() {
        return {
            searchArr: {
                chat_id: ''
            },
            timer: '',
            searchChatList: [],
            searchLoading: false,
            chatInfoDrawer: false,
            ChatId: [],
            doBindStatus: false,
            order_num_chat_data: [],
        }
    },
    watch: {
        order_num(n) {
            this.searchArr.chat_id = ''
            this.ChatId = []
            this.order_num_chat_data = []
            if (n) {
                this.HasChatData(n)
            }
        },
        'searchArr.chat_id': {
            handler() {
                if (this.timer) {
                    clearTimeout(this.timer)
                }
                this.timer = setTimeout(() => {
                    this.searchNameremoteMethod(this.searchArr.chat_id)
                }, 300)
            },
            deep: true,
        },
    },
    methods: {
        searchNameremoteMethod(query) {
            if (query !== '') {
                this.searchLoading = true
                setTimeout(() => {
                    this.searchLoading = false
                    this.searchChats(query)
                }, 200)
            } else {
                this.ChatId = []
            }
        },
        searchChats(query) {
            this.$axios
                .get('/api/admin/userGroups/searchChats/' + query)
                .then(res => {
                    let { data } = res
                    if (data.code === 0) {
                        // this.searchChatList = data.data
                        this.$nextTick(() => {
                            console.log(data.data)
                            this.ChatId = data.data
                        })
                    }
                })
        },
        handleSearchNameChange(val) {
            this.$nextTick(() => {
                this.ChatId = val
            })
        },
        doBind(val) {
            this.doBindStatus = val
        },
        execBind(val) {
            this.$axios.put('api/ysy_order_bind_we_chat_do_bind', {
                ...val,
                order_num: this.order_num
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ChatId = ''
                    this.searchArr.chat_id = ''
                    this.$emit('success')
                    this.$message.success(data.msg)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        HasChatData(order_num) {
            this.$axios.get('api/ysy_order_bind_we_chat_has_order',{
                params: {
                    order_num
                }
            }).then(({data}) => {
                if (data.code === 200) {
                    this.$nextTick(() => {
                        this.order_num_chat_data = data.data
                    })
                } 
            }).catch()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/common/BindWeChat.vue